
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'project-card-placeholder'
})
export default class ProjectCardPlaceholder extends Vue {
}
